module.exports = __webpack_public_path__ + "static/media/СЗФО_2016.0cb10771.png";